interface Env {
  apiUrl: string;
  jwtToken: string;
  groqApiKey: string;
}

export const env: Env = {
  apiUrl: import.meta.env.VITE_API_URL || 'http://localhost:3000',
  jwtToken: import.meta.env.VITE_JWT_TOKEN || '',
  groqApiKey: import.meta.env.VITE_GROQ_API_KEY || '',
};